export var ShadowMode;
(function (ShadowMode) {
    ShadowMode[ShadowMode["None"] = 0] = "None";
    ShadowMode[ShadowMode["Hard"] = 1] = "Hard";
    ShadowMode[ShadowMode["SoftLow"] = 2] = "SoftLow";
    ShadowMode[ShadowMode["SoftHigh"] = 3] = "SoftHigh";
})(ShadowMode || (ShadowMode = {}));
